import type { SearchSelectFilterType } from '@/scopes/search/search/infrastructure/api/types'
import { Dropdown } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'

interface DistanceFilterDropdownProps {
  filterType: SearchSelectFilterType
  labelId: string
  analyticsType: string
  dataQa: string
}

export function DistanceFilterDropdown({ filterType, labelId, analyticsType, dataQa }: DistanceFilterDropdownProps) {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { isFetching, options, selectedValue, setSelection } = useSelectFilter(filterType)

  const handleFilterChange = (value?: string) => {
    if (value) {
      setSelection(value)
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: analyticsType,
          result: value,
        }),
      )
    }
    else {
      setSelection(null)
    }
  }

  if (isEmpty(options))
    return null

  return (
    <Dropdown.Root value={selectedValue} onValueChange={handleFilterChange} disabled={isFetching}>
      <Dropdown.Trigger
        placeholder={intl.formatMessage({ id: 'make_a_choice_placeholder' })}
        label={intl.formatMessage({ id: labelId })}
        attributes={{ 'data-qa': dataQa }}
      />
      <Dropdown.Content>
        <Dropdown.EmptyValueItem>
          {intl.formatMessage({ id: 'make_a_choice_placeholder' })}
        </Dropdown.EmptyValueItem>
        {options.map(({ name, value }) => (
          <Dropdown.Item key={value} value={value}>
            {name}
          </Dropdown.Item>
        ))}
      </Dropdown.Content>
    </Dropdown.Root>
  )
}
